__webpack_require__.p = "https://cdn-static.mgcc.com.cn/oa-rebate-fe-prod/";